"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getLoadingIndicatorColor = function getLoadingIndicatorColor(_ref) {
  var color = _ref.color,
      buttonVariant = _ref.buttonVariant;

  if (!buttonVariant) {
    return "blue";
  }

  if (!color) {
    return "black";
  }

  switch (color) {
    case 'primary':
      return "white";

    default:
      return "white";
  }
};

var LoadingIndicator = function LoadingIndicator(_ref2) {
  var color = _ref2.color,
      buttonVariant = _ref2.buttonVariant;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.ActivityIndicator, {
    size: "small",
    style: {
      marginRight: 4
    },
    color: getLoadingIndicatorColor({
      color: color,
      buttonVariant: buttonVariant
    })
  });
};

var _default = function _default(_ref3) {
  var loading = _ref3.loading,
      icon = _ref3.icon,
      startIcon = _ref3.startIcon,
      endIcon = _ref3.endIcon,
      color = _ref3.color,
      variant = _ref3.variant,
      props = _objectWithoutProperties(_ref3, ["loading", "icon", "startIcon", "endIcon", "color", "variant"]);

  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({}, props, {
    startIcon: loading ? /*#__PURE__*/_react["default"].createElement(LoadingIndicator, {
      buttonVariant: variant,
      color: color
    }) : startIcon || icon,
    endIcon: !loading && endIcon,
    color: color,
    variant: variant
  }));
};

exports["default"] = _default;